import React, { Component } from 'react'
import { Modal, Select, message } from 'antd'

export default class EuotetDepartmengt extends Component {
    state = {
        visible: false,
        params: {},
        }

    show = () => {
        this.setState({
            visible: true,
            params: {},
        });
    }

    sumbit = () => {
        const { params: { HospitalDepartmentId } } = this.state;
        if(!HospitalDepartmentId){
            message.warning('请选择院区')
            return
        }
        this.confirmTip();
        this.hide();
    }

    confirmTip = () => {
        const { loadData } = this.props;
        const { params: { HospitalDepartmentId } } = this.state;
        Modal.confirm({
            title: '科室信息引用确认',
            content: '该科室在该院区下已有相关数据，确定引用吗？',
            onOk() {
                loadData(HospitalDepartmentId);
            },
            onCancel() {
                
            },
        });
        
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    handleChange = (value) => {
        const { changeHospitalDepartmentId } = this.props;
        changeHospitalDepartmentId(value);
        this.setState({
            params:{
                HospitalDepartmentId: value,
            }
        })
    }

render() {
    const { visible, params } = this.state;
    const asterisk = <span style={{ color: 'red' }}>*</span>;
    const { List } = this.props;
    const Option = Select.Option;
    const hospitalOptions = List.map( i => <Option value={i.hospitalName} > {i.hospitalName} </Option>)
    const courtyardAreaOptions = List.map( i => <Option value={i.hospitalDepartmentId} > {i.courtyardArea} </Option>)
    return (
        <Modal
            title="院区科室信息引用确认"
            visible={visible}
            onOk={this.sumbit}
            onCancel={this.hide}
        >
            <div className="modal-content" style={{ padding: "0 20px" }}>
                <ul className="modal-list">
                <li className="modal-item">
                    <div className="item-left" style={{ width: "27%" }}>{asterisk}医院:</div>
                    <div className="item-right" style={{ width: "73%" }}>
                        <Select
                            style={{ width: 220 }}
                            disabled={true}
                            value = {List[0]? List[0].hospitalName : ''}
                        >
                            {hospitalOptions}
                        </Select>
                    </div>
                </li>
                <li className="modal-item">
                    <div className="item-left" style={{ width: "27%" }}>{asterisk}院区:</div>
                    <div className="item-right" style={{ width: "73%" }}>
                        <Select
                            style={{ width: 220 }}
                            value={params.HospitalDepartmentId}
                            onChange={ value => this.handleChange(value)}
                        >
                            {courtyardAreaOptions}
                        </Select>
                    </div>
                </li>
            </ul>
        </div>
        </Modal>
    )
    }
}



// WEBPACK FOOTER //
// ./src/components/hospital/commentInfo/EuotetDepartmengt.js